/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { SessionClosePolicy } from './SessionClosePolicy';
export type PreferencesNullable = {
    preferences?: {
        /**
         * ID of hidden vehicles on the main map
         */
        hidden_vehicles?: Array<string>;
        /**
         * Show operators instead of vehicles on the main map
         */
        operators_on_map?: boolean;
        /**
         * Show operator "Last name | First name"
         */
        show_last_name_first?: boolean;
        /**
         * Station transactions default type
         */
        station_transactions?: PreferencesNullable.station_transactions | null;
        vehicle_session_policy?: SessionClosePolicy;
    } | null;
};
export namespace PreferencesNullable {
    /**
     * Station transactions default type
     */
    export enum station_transactions {
        IN = 'in',
        OUT = 'out',
    }
}

